import { ButtonBasic } from "@lk-gtcom/ecomlab-components";
import { ModalComponent } from "../../ModalComponent/ModalComponent";
import './ModalExitReadyScenario.scss'

const ModalExitReadyScenario = ({
    setIsModal,
    onClose,
    onSave
}) => {

    return (
        <ModalComponent
            onClose={e => setIsModal(false)}
            title="У вас есть не сохраненные изменения"
            style={{
                maxWidth: '500px',
                height: 'auto'
            }}
            child={
                <div className='modal-exit-ready-scenario'>
                    <div className='modal-exit-ready-scenario__group-btn'>
                        <ButtonBasic
                            grey
                            text='Продолжить редактирование'
                            width='100%'
                            onClick={(e) => setIsModal(false)}
                        />
                        <ButtonBasic
                            green
                            text='Сохранить и выйти'
                            width='100%'
                            onClick={onSave}
                        />
                        <ButtonBasic
                            red
                            text='Выйти'
                            width='100%'
                            onClick={onClose}
                        />
                    </div>
                </div>
            }
        />
    )
}

export { ModalExitReadyScenario }